import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '@media (max-width: 1450px)': {
        justifyContent: 'flex-end'
      },
      '@media (max-width: 520px)': {
        width: '100%',
        overflowX: 'auto',
        overflowY: 'hidden'
      },
      '@media (max-width: 768px)': {
        position: 'relative',
        bottom: '-10px',
        zIndex: 1
      }
    },
    mobileNav: {
      width: '100%',
      height: '70px',
      backgroundColor: 'white',
      padding: '10px 0px 0px 0px',
      borderRadius: '10px 10px 0px 0px',
      '@media (min-width: 768px)': {
        display: 'none'
      }
    },
    filters: {
      display: 'flex',
      alignItems: 'end',
      gap: '10px',
      justifyContent: 'flex-end',
      '@media (max-width: 767px)': {
        display: 'none'
      }
    },
    title: {
      '@media (max-width: 1450px)': {
        display: 'none'
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
